import type { FormikHelpers } from "formik";
import type { ResourceResponse } from "types";
import { useTypedSelector, useSimpleRequest } from "hooks";
import { FormAdapter } from "hooks/useForm";
import { SetupIdentifier } from "consts/setups";
import { executeOnSuccess } from "util/api";
import type { Consumer } from "features/consumers/types";
import { postConsumer } from "features/consumers/api";
import { selectSetupsSlice } from "features/setups/selectors";
import type { AddConsumerProps } from "./types";

export default function useAddConsumer({
    onAdd = _ => {}
}: AddConsumerProps) {
    const domains = useTypedSelector(selectSetupsSlice(SetupIdentifier.Mors));
    const request = useSimpleRequest();

    return async ({ email, firstName, lastName, active }: Partial<Consumer>, formikHelpers?: FormikHelpers<Partial<Consumer>>) => {
        const response = await request(() => postConsumer({
            hashedEmail: email,
            firstName,
            lastName,
            active: active,
            MOR: domains.MOR
        }));

        executeOnSuccess(
            response,
            (response: ResourceResponse<Consumer>) => {
                formikHelpers?.resetForm();
                onAdd(response);
            }
        );

        return FormAdapter.fromResponse(response);
    };
};
